import * as Yup from 'yup';
import { TextNote } from '@models';

export function useValidationSchema() {
  return Yup.object<TextNote>().shape({
    text: Yup.string().nullable().required(),
  });
}
